import { ProjectUser, ProjectVersion, Workflow } from '@app/shared/interfaces';
import { toValidDate } from '@app/shared/helpers/date-formatting.helper';

export class DisplayUtils {
  static getUserNameById(userId: number | null | undefined, projectUsers: ProjectUser[]): string {
    if (userId == null) return '';
    const user = projectUsers.find(u => u.userId === userId);
    return user?.userName ?? '';
  }

  static getWorkflowNameById(workflowId: number | null | undefined, projectWorkflows: Workflow[]): string {
    if (workflowId == null) return '';
    const workflow = projectWorkflows.find(w => w.workflowId === workflowId);
    return workflow?.name ?? '';
  }

  static getVersionNameById(versionId: number | null | undefined, projectVersions: ProjectVersion[]): string {
    if (versionId == null) return '';
    const version = projectVersions.find(v => v.versionId === versionId);
    return version ? DisplayUtils.getVersionDisplay(version) : '';
  }

  static getVersionDisplay(version: ProjectVersion): string {
    return `${version.majorVersion}.${version.minorVersion}`;
  }

  static formatVersionDate(timestamp: string): string {
    const date = toValidDate(timestamp);
    if (!date) return '';
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).replace(',', '');
  }

  static isHeadVersion(version: ProjectVersion): boolean {
    return version.majorVersion === 0 && version.minorVersion === 0;
  }
}

